import { render, staticRenderFns } from "./TagFilters.vue?vue&type=template&id=6efa25b4&scoped=true&"
import script from "./TagFilters.vue?vue&type=script&lang=js&"
export * from "./TagFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=6efa25b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa25b4",
  null
  
)

export default component.exports